document.addEventListener('DOMContentLoaded', function() {
  const selects = document.querySelectorAll('.plp-form__options');

  selects.forEach(select => {
    select.addEventListener('change', function(event) {

      const value = this.value;
      const form = this.closest('.plp-form');

      const prices = form.querySelectorAll('.plp-form__price');
      prices.forEach(price => {
        price.classList.remove('active');
      });

      const activePrice = form.querySelector(`.plp-form__price[data-variantid='${value}']`);
      if (activePrice) {
        activePrice.classList.add('active');
      }

      const productIdInput = form.querySelector('.product-variant-id');
      if (productIdInput) {
        productIdInput.value = value;
      }

      /* Update availability on the submit button */
      const selectedOption = this.options[this.selectedIndex];
      const isAvailable = selectedOption.getAttribute('data-available') === "true";
      form.querySelector('.quick-add__submit').disabled = !isAvailable;

    });
  });

});
